<template>
  <CCardBody>
    <CRow class="pt-4 pb-4 rowCartItem" v-for="(pack, index) in cartPackges" :key="index">
      <CCol md="2">
        <div class="d-flex">
          <div>
            <div class="d-flex mt-2 add-or-subtract">
              <div class="p-2 pl-3 pr-3 font-weight-bold">{{ pack.quantity }}</div>
            </div>
          </div>
        </div>
      </CCol>

      <CCol md="6">
        <div class="d-flex pt-3">
          <CIcon :name="pack.channel" class="" size="custom-size" label="teste" :height="25" viewBox="0 0 32 32" />
          <div class="mb-0 font-md ml-2 font-weight-bold">{{ pack.packName }}</div>
        </div>

        <div class="col-md-12">
          <div class="inTotal">{{ pack.quantityPackage }} {{ pack.channel }} {{ $t('balance.components.cart.inTotal') }}</div>
        </div>
        <div class="col-md-12" v-if="pack.channel == 'sms'">
          <div class="flagCountryAfterTotal">
            <img :src="getCountryData(pack.country).flag" width="25" height="auto" class="mr-2" />
            <strong>{{ getCountryData(pack.country).label }}</strong>
          </div>
        </div>
      </CCol>

      <CCol md="4">
        <div v-if="pack.package.packSelected.addOnRecurrenceType == 1" class="pt-2">{{ $t('balance.components.cart.recurringPack') }}</div>
        <div v-if="pack.package.packSelected.addOnRecurrenceType == 2" class="pt-2">{{ $t('balance.components.cart.oneShot') }}</div>
        <div class="pt-1 font-weight-bold">
          {{ pack.package.packSelected.price && pack.quantity ? formatNumber(pack.package.packSelected.price * pack.quantity) : '' }} €
          <span v-if="pack.package.packSelected.addOnRecurrenceType == 1">/ {{ $t('balance.components.cart.month') }}</span>
        </div>
      </CCol>
    </CRow>
  </CCardBody>
</template>

<script>
import { currencyFormat, currencyFormatStyleEnum } from '@/utils/numbersFormatUtil.js'
import { nameCountries } from '@/utils/countriesUtils.js'

export default {
  name: 'CardPlan',
  computed: {
    isSummary() {
      return this.place == 'summary'
    },
    planName() {
      return this.$store.state.balance.steps.selectedPlanName.toLowerCase()
    },
    packSelected() {
      return this.$store.state.balance.steps.package.packSelected
    },
    emails() {
      return this.$store.state.balance.steps.maxEmailsIncluded
    },
    contacts() {
      return this.$store.state.balance.steps.maxAudience
    },
    period() {
      return this.$store.state.balance.steps.paymentPeriod
    },
    channel() {
      return this.$store.state.balance.steps.channel
    },
    quantityPackage() {
      return this.$store.state.balance.steps.quantityPackage
    },
    cartPackges() {
      return this.$store.state.balance.steps.cartPackges
    },
  },
  methods: {
    formatNumber(number) {
      return currencyFormat(number, currencyFormatStyleEnum.DECIMAL)
    },

    prev() {
      this.$store.dispatch('backOffice/steps/setCurrentStep', 1)
    },

    applyDiscount(value) {
      if (this.period == 3) {
        let discount = value * 0.1
        let newValue = value - discount
        return newValue.toFixed(1)
      }

      return value
    },

    getCountryData(country) {
      const item = nameCountries(this).filter((item) => item.value.toUpperCase() == country.toUpperCase())
      if (item[0]) {
        return { ...item[0] }
      }
      return ''
    },
  },
}
</script>

<style lang="scss">
.inTotal {
  color: #868e96;
  margin-left: 19px;
}

.flagCountryAfterTotal {
  margin-left: 20px;
}
</style>
